(function () {
  /* czas w Polsce, niezależnie od strefy klienta */
  function warsawNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Warsaw', hour12: false,
        weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var days = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
      return { day: days[o.weekday], h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10), s: parseInt(o.second, 10) };
    } catch (e) {
      var d = new Date();
      return { day: d.getDay(), h: d.getHours(), m: d.getMinutes(), s: d.getSeconds() };
    }
  }
  /* 'today' | 'tomorrow' | 'monday' + sekundy do godziny granicznej */
  function shipState(cutoff, weekends) {
    var n = warsawNow();
    var secNow = n.h * 3600 + n.m * 60 + n.s;
    var secCut = cutoff * 3600;
    var isWeekend = n.day === 6 || n.day === 0;
    if (!weekends && isWeekend) return { state: 'monday', left: 0, frac: 0 };
    if (secNow < secCut) return { state: 'today', left: secCut - secNow, frac: secNow / secCut };
    if (!weekends && n.day === 5) return { state: 'monday', left: 0, frac: 1 };
    return { state: 'tomorrow', left: 0, frac: 1 };
  }
  function fmt(sec) {
    var h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60);
    if (h > 0) return h + ' h ' + m + ' min';
    return Math.max(m, 1) + ' min';
  }

  function updateBadges() {
    document.querySelectorAll('[data-nk-ship-badge]').forEach(function (el) {
      var st = shipState(parseInt(el.dataset.cutoff, 10) || 14, el.dataset.weekend === 'true');
      var txt = st.state === 'today' ? el.dataset.today : (st.state === 'monday' ? el.dataset.monday : el.dataset.tomorrow);
      var t = el.querySelector('[data-nk-ship-text]');
      if (t && txt) t.textContent = txt;
      el.classList.toggle('is-live', st.state === 'today');
    });
    document.querySelectorAll('[data-nk-cutoff]').forEach(function (el) {
      var st = shipState(parseInt(el.dataset.cutoff, 10) || 14, el.dataset.weekend === 'true');
      var t = el.querySelector('[data-nk-cutoff-text]');
      var bar = el.querySelector('[data-nk-cutoff-bar]');
      var html;
      if (st.state === 'today') {
        html = (el.dataset.before || '').replace('{czas}', '<strong>' + fmt(st.left) + '</strong>');
      } else {
        var day = st.state === 'monday' ? el.dataset.monday : el.dataset.tomorrow;
        html = (el.dataset.after || '').replace('{dzien}', '<strong>' + (day || '') + '</strong>');
      }
      if (t) t.innerHTML = html;
      if (bar) bar.style.width = (st.state === 'today' ? Math.round(st.frac * 100) : 100) + '%';
      el.classList.toggle('is-closed', st.state !== 'today');
    });
  }

  function initToast() {
    var toast = document.querySelector('[data-nk-toast]');
    if (!toast) return;
    var key = toast.dataset.key;
    try { if (sessionStorage.getItem(key) === '1') return; } catch (e) {}
    if (toast.parentElement !== document.body) document.body.appendChild(toast);
    var delay = (parseInt(toast.dataset.delay, 10) || 3) * 1000;
    var hideAfter = (parseInt(toast.dataset.hide, 10) || 0) * 1000;
    var hideTimer;
    function close(remember) {
      toast.classList.remove('is-in');
      setTimeout(function () { toast.hidden = true; }, 450);
      if (remember) { try { sessionStorage.setItem(key, '1'); } catch (e) {} }
    }
    setTimeout(function () {
      if (window.innerWidth < 750 && document.querySelector('.ProductStickyAddToCart, [class*="StickyAddToCart"]')) toast.classList.add('is-raised');
      toast.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { toast.classList.add('is-in'); }); });
      if (hideAfter > 0) hideTimer = setTimeout(function () { close(false); }, hideAfter);
    }, delay);
    toast.querySelector('[data-nk-toast-close]').addEventListener('click', function () {
      clearTimeout(hideTimer); close(true);
    });
    toast.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
  }

  function start() {
    updateBadges();
    setInterval(updateBadges, 30000);
    initToast();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { updateBadges(); });
})();
